<script setup>
  import { useRoute } from 'vue-router'

  import { computed } from 'vue'

  import { useClubRouter } from '@/features/router/useClubRouer.js'
  import CustomTab from '@/features/ui/components/tab/CustomTab.vue'

  const route = useRoute()
  const currentTabValue = computed(() => route.path)

  const items = computed(() => {
    const endpoints = '/dev-mode/endpoints'
    const usersList = '/dev-mode/users-list'
    const userInfo = '/dev-mode/user-info'
    const updateMobileVersion = '/dev-mode/update-mobile-version'

    function isActive(value) {
      return currentTabValue.value.includes(value)
    }

    return [
      {
        value: usersList,
        label: 'Users List',
        active: isActive(usersList),
      },
      {
        value: userInfo,
        label: 'User Info',
        active: isActive(userInfo),
      },
      {
        value: updateMobileVersion,
        label: 'Update Mobile Version',
        active: isActive(updateMobileVersion),
      },
      {
        value: endpoints,
        label: 'Endpoints',
        active: isActive(endpoints),
      },
    ]
  })

  const router = useClubRouter()
  function handleTabChange(value) {
    router.push(value)
  }
</script>

<template>
  <div class="dev-mode-layout">
    <div class="page-inner">
      <CustomTab
        v-model="currentTabValue"
        :tabs="items"
        alignment="left"
        @change="handleTabChange"
      />

      <Message> This page developed for internal purposes. </Message>

      <div class="router-view">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .dev-mode-layout {
    padding: 20px;
    background: light-dark(#ececec, #232323);
    width: 100%;
  }

  .page-inner {
    background: light-dark(rgba(255, 255, 255, 0.8), rgba(0, 0, 0, 0.8));
    border-radius: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 900px;
    margin: 0 auto;
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
  }

  .router-view {
  }
</style>
